export const COUNTRY_CONFIG_MAP = {
  de: {
    tableShow: {
      plate: false,
      vin: true,
    },
    attribute: {
      primary: 'vin',
    },
    carDetails: {
      mainFeatures: ['vin'],
      secondaryFeatures: [],
    },
  },
  fr: {
    tableShow: {
      plate: false,
      vin: true,
    },
    attribute: {
      primary: 'vin',
    },
    carDetails: {
      mainFeatures: ['vin'],
      secondaryFeatures: [],
    },
  },
  it: {
    tableShow: {
      plate: true,
      vin: false,
    },
    attribute: {
      primary: 'plate',
    },
    carDetails: {
      mainFeatures: ['plate'],
      secondaryFeatures: ['vin'],
    },
  },
}
